import { StyleHelper } from '../helpers/style-helper';

export class SubStateItem {
  // id = '';  we don't use this, it is not provided by backend
  text = '';
  description = '';
  backgroundColor = '';
  foregroundColor = '';
  orderCanBeClosed = true;
  originalValue = '';
  displayText = '';

  getStyle(): string {
    return StyleHelper.getColorStyle(this.backgroundColor, this.foregroundColor);
  }
}
